import script from "./ProjectTasksList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTasksList.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTasksList.vue?vue&type=style&index=0&id=35e6d760&lang=scss&scoped=true"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e6d760"]])

export default __exports__